/**
 * Single source of truth for the primary public navigation.
 *
 * `Navbar.tsx` renders these links (desktop + mobile) and `PublicJsonLd.tsx`
 * mirrors them into a `SiteNavigationElement` JSON-LD list — both read from
 * this constant so the visible nav and the structured data can never
 * disagree. `labelKey` is an i18n key under `nav.*`, already used by the
 * navbar before this file existed.
 */

export interface SiteSection {
  path: string
  labelKey: string
}

export const PRIMARY_NAV_SECTIONS: readonly SiteSection[] = [
  { path: '/', labelKey: 'nav.home' },
  { path: '/investigations', labelKey: 'nav.investigations' },
  { path: '/investigators', labelKey: 'nav.investigators' },
  { path: '/about', labelKey: 'nav.about' },
]
